// ---------------- AWS Cloud ----------------
import AWS_Cloud_Benefits from "./aws_components/AWS_Cloud/AWS_Cloud_Benefits.jsx";
import AWS_Cloud_Certification from "./aws_components/AWS_Cloud/AWS_Cloud_Certification.jsx";
import AWS_Cloud_Computing from "./aws_components/AWS_Cloud/AWS_Cloud_Computing.jsx";
import AWS_Get_Started from "./aws_components/AWS_Cloud/AWS_Get_Started.jsx";
import AWS_HOME from "./aws_components/AWS_Cloud/AWS_HOME.jsx";
import AWS_Intro from "./aws_components/AWS_Cloud/AWS_Intro.jsx";

// ---------------- AWS Cloud Journey ----------------
import AWS_Cloud_Benefits_Journey from "./aws_components/AWS_Cloud_Journey/AWS_Cloud_Benefits.jsx";
import AWS_Well_Architected_Framework from "./aws_components/AWS_Cloud_Journey/AWS_Well_Architected_Framework.jsx";

// ---------------- AWS Cloud Security ----------------
import AWS_Cloud_Compliance from "./aws_components/AWS_Cloud_Security/AWS_Cloud_Compliance.jsx";
import AWS_DDoS from "./aws_components/AWS_Cloud_Security/AWS_DDoS.jsx";
import AWS_Organizations from "./aws_components/AWS_Cloud_Security/AWS_Organizations.jsx";
import AWS_Other_Services from "./aws_components/AWS_Cloud_Security/AWS_Other_Services.jsx";
import AWS_Shared_Responsibility from "./aws_components/AWS_Cloud_Security/AWS_Shared_Responsibility.jsx";
import AWS_User_Access from "./aws_components/AWS_Cloud_Security/AWS_User_Access.jsx";

// ---------------- AWS EC2 ----------------
import AWS_EC2_Auto_Scaling from "./aws_components/AWS_EC2/AWS_EC2_Auto_Scaling.jsx";
import AWS_EC2_Instance_Types from "./aws_components/AWS_EC2/AWS_EC2_Instance_Types.jsx";
import AWS_EC2_Intro from "./aws_components/AWS_EC2/AWS_EC2_Intro.jsx";
import AWS_EC2_Pricing from "./aws_components/AWS_EC2/AWS_EC2_Pricing.jsx";
import AWS_EC2_Scaling from "./aws_components/AWS_EC2/AWS_EC2_Scaling.jsx";
import AWS_Elastic_Load_Balancing from "./aws_components/AWS_EC2/AWS_Elastic_Load_Balancing.jsx";

// ---------------- Exam Preparation ----------------
import AWS_Exam_Preparation from "./aws_components/AWS_Exam_Preparation/AWS_Exam_Preparation.jsx";

// ---------------- Examples ----------------
import AWS_Certificate from "./aws_components/AWS_Examples/AWS_Certificate.jsx";
import AWS_Cloud_Exercises from "./aws_components/AWS_Examples/AWS_Cloud_Exercises.jsx";
import AWS_Cloud_Quiz from "./aws_components/AWS_Examples/AWS_Cloud_Quiz.jsx";

// ---------------- Infrastructure ----------------
import AWS_Availability_Zones from "./aws_components/AWS_Infrastructure/AWS_Availability_Zones.jsx";
import AWS_Edge_Locations from "./aws_components/AWS_Infrastructure/AWS_Edge_Locations.jsx";
import AWS_Regions from "./aws_components/AWS_Infrastructure/AWS_Regions.jsx";

// ---------------- Messaging ----------------
import AWS_SNS from "./aws_components/AWS_Messaging/AWS_SNS.jsx";
import AWS_SQS from "./aws_components/AWS_Messaging/AWS_SQS.jsx";

// ---------------- Migration & Innovation ----------------
import AWS_CAF from "./aws_components/AWS_Migration_and_Innovation/AWS_CAF.jsx";
import AWS_Innovation from "./aws_components/AWS_Migration_and_Innovation/AWS_Innovation.jsx";
import AWS_Migration_Strategies from "./aws_components/AWS_Migration_and_Innovation/AWS_Migration_Strategies.jsx";
import AWS_Snow_Family from "./aws_components/AWS_Migration_and_Innovation/AWS_Snow_Family.jsx";

// ---------------- Monitoring & Analytics ----------------
import AWS_CloudTrail from "./aws_components/AWS_Monitoring_and_Analytics/AWS_CloudTrail.jsx";
import AWS_CloudWatch from "./aws_components/AWS_Monitoring_and_Analytics/AWS_CloudWatch.jsx";
import AWS_TrustedAdvisor from "./aws_components/AWS_Monitoring_and_Analytics/AWS_TrustedAdvisor.jsx";

// ---------------- Networking ----------------
import AWS_Connectivity from "./aws_components/AWS_Networking/AWS_Connectivity.jsx";
import AWS_Global_Networking from "./aws_components/AWS_Networking/AWS_Global_Networking.jsx";
import AWS_Subnet_and_Access from "./aws_components/AWS_Networking/AWS_Subnet_and_Access.jsx";

// ---------------- Pricing & Support ----------------
import AWS_Billing_Dashboard from "./aws_components/AWS_Pricing_and_Support/AWS_Billing_Dashboard.jsx";
import AWS_Budgets from "./aws_components/AWS_Pricing_and_Support/AWS_Budgets.jsx";
import AWS_Consolidated_Billing from "./aws_components/AWS_Pricing_and_Support/AWS_Consolidated_Billing.jsx";
import AWS_Cost_Explorer from "./aws_components/AWS_Pricing_and_Support/AWS_Cost_Explorer.jsx";
import AWS_Free_Tier from "./aws_components/AWS_Pricing_and_Support/AWS_Free_Tier.jsx";
import AWS_Marketplace from "./aws_components/AWS_Pricing_and_Support/AWS_Marketplace.jsx";
import AWS_Pricing_Models from "./aws_components/AWS_Pricing_and_Support/AWS_Pricing_Models.jsx";
import AWS_Support_Plans from "./aws_components/AWS_Pricing_and_Support/AWS_Support_Plans.jsx";

// ---------------- Provision ----------------
import AWS_CloudFormation from "./aws_components/AWS_Provision/AWS_CloudFormation.jsx";
import AWS_Elastic_Beanstalk from "./aws_components/AWS_Provision/AWS_Elastic_Beanstalk.jsx";
import AWS_Provision_Services from "./aws_components/AWS_Provision/AWS_Provision_Services.jsx";

// ---------------- Serverless & Containers ----------------
import AWS_Containers from "./aws_components/AWS_Serverless_&_Containers/AWS_Containers.jsx";
import AWS_ECS from "./aws_components/AWS_Serverless_&_Containers/AWS_ECS.jsx";
import AWS_EKS from "./aws_components/AWS_Serverless_&_Containers/AWS_EKS.jsx";
import AWS_Fargate from "./aws_components/AWS_Serverless_&_Containers/AWS_Fargate.jsx";
import AWS_Lambda from "./aws_components/AWS_Serverless_&_Containers/AWS_Lambda.jsx";
import AWS_Serverless from "./aws_components/AWS_Serverless_&_Containers/AWS_Serverless.jsx";

// ---------------- Storage & Databases ----------------
import AWS_Additional_DB_Services from "./aws_components/AWS_Storage_and_Databases/AWS_Additional_DB_Services.jsx";
import AWS_DMS from "./aws_components/AWS_Storage_and_Databases/AWS_DMS.jsx";
import AWS_DynamoDB from "./aws_components/AWS_Storage_and_Databases/AWS_DynamoDB.jsx";
import AWS_DynamoDB_vs_RDS from "./aws_components/AWS_Storage_and_Databases/AWS_DynamoDB_vs_RDS.jsx";
import AWS_EBS from "./aws_components/AWS_Storage_and_Databases/AWS_EBS.jsx";
import AWS_EBS_vs_S3 from "./aws_components/AWS_Storage_and_Databases/AWS_EBS_vs_S3.jsx";
import AWS_Elastic_File_System from "./aws_components/AWS_Storage_and_Databases/AWS_Elastic_File_System.jsx";
import AWS_Instance_Stores from "./aws_components/AWS_Storage_and_Databases/AWS_Instance_Stores.jsx";
import AWS_RDS from "./aws_components/AWS_Storage_and_Databases/AWS_RDS.jsx";
import AWS_Redshift from "./aws_components/AWS_Storage_and_Databases/AWS_Redshift.jsx";
import AWS_S3 from "./aws_components/AWS_Storage_and_Databases/AWS_S3.jsx";

// ---------------- More AWS ----------------
import AWS_Machine_Learning from "./aws_components/More_AWS/AWS_Machine_Learning.jsx";
import AWS_Serverless_More from "./aws_components/More_AWS/AWS_Serverless.jsx";

// ======================================================================
// COMPONENTS OBJECT (JSX-like keys)
// ======================================================================
const AllAwsComponents = {
  // Cloud
  "<AWS_Cloud_Benefits />": AWS_Cloud_Benefits,
  "<AWS_Cloud_Certification />": AWS_Cloud_Certification,
  "<AWS_Cloud_Computing />": AWS_Cloud_Computing,
  "<AWS_Get_Started />": AWS_Get_Started,
  "<AWS_HOME />": AWS_HOME,
  "<AWS_Intro />": AWS_Intro,

  // Cloud Journey
  "<AWS_Cloud_Benefits_Journey />": AWS_Cloud_Benefits_Journey,
  "<AWS_Well_Architected_Framework />": AWS_Well_Architected_Framework,

  // Cloud Security
  "<AWS_Cloud_Compliance />": AWS_Cloud_Compliance,
  "<AWS_DDoS />": AWS_DDoS,
  "<AWS_Organizations />": AWS_Organizations,
  "<AWS_Other_Services />": AWS_Other_Services,
  "<AWS_Shared_Responsibility />": AWS_Shared_Responsibility,
  "<AWS_User_Access />": AWS_User_Access,

  // EC2
  "<AWS_EC2_Auto_Scaling />": AWS_EC2_Auto_Scaling,
  "<AWS_EC2_Instance_Types />": AWS_EC2_Instance_Types,
  "<AWS_EC2_Intro />": AWS_EC2_Intro,
  "<AWS_EC2_Pricing />": AWS_EC2_Pricing,
  "<AWS_EC2_Scaling />": AWS_EC2_Scaling,
  "<AWS_Elastic_Load_Balancing />": AWS_Elastic_Load_Balancing,

  // Exam Preparation
  "<AWS_Exam_Preparation />": AWS_Exam_Preparation,

  // Examples
  "<AWS_Certificate />": AWS_Certificate,
  "<AWS_Cloud_Exercises />": AWS_Cloud_Exercises,
  "<AWS_Cloud_Quiz />": AWS_Cloud_Quiz,

  // Infrastructure
  "<AWS_Availability_Zones />": AWS_Availability_Zones,
  "<AWS_Edge_Locations />": AWS_Edge_Locations,
  "<AWS_Regions />": AWS_Regions,

  // Messaging
  "<AWS_SNS />": AWS_SNS,
  "<AWS_SQS />": AWS_SQS,

  // Migration & Innovation
  "<AWS_CAF />": AWS_CAF,
  "<AWS_Innovation />": AWS_Innovation,
  "<AWS_Migration_Strategies />": AWS_Migration_Strategies,
  "<AWS_Snow_Family />": AWS_Snow_Family,

  // Monitoring & Analytics
  "<AWS_CloudTrail />": AWS_CloudTrail,
  "<AWS_CloudWatch />": AWS_CloudWatch,
  "<AWS_TrustedAdvisor />": AWS_TrustedAdvisor,

  // Networking
  "<AWS_Connectivity />": AWS_Connectivity,
  "<AWS_Global_Networking />": AWS_Global_Networking,
  "<AWS_Subnet_and_Access />": AWS_Subnet_and_Access,

  // Pricing & Support
  "<AWS_Billing_Dashboard />": AWS_Billing_Dashboard,
  "<AWS_Budgets />": AWS_Budgets,
  "<AWS_Consolidated_Billing />": AWS_Consolidated_Billing,
  "<AWS_Cost_Explorer />": AWS_Cost_Explorer,
  "<AWS_Free_Tier />": AWS_Free_Tier,
  "<AWS_Marketplace />": AWS_Marketplace,
  "<AWS_Pricing_Models />": AWS_Pricing_Models,
  "<AWS_Support_Plans />": AWS_Support_Plans,

  // Provision
  "<AWS_CloudFormation />": AWS_CloudFormation,
  "<AWS_Elastic_Beanstalk />": AWS_Elastic_Beanstalk,
  "<AWS_Provision_Services />": AWS_Provision_Services,

  // Serverless & Containers
  "<AWS_Containers />": AWS_Containers,
  "<AWS_ECS />": AWS_ECS,
  "<AWS_EKS />": AWS_EKS,
  "<AWS_Fargate />": AWS_Fargate,
  "<AWS_Lambda />": AWS_Lambda,
  "<AWS_Serverless />": AWS_Serverless,

  // Storage & Databases
  "<AWS_Additional_DB_Services />": AWS_Additional_DB_Services,
  "<AWS_DMS />": AWS_DMS,
  "<AWS_DynamoDB />": AWS_DynamoDB,
  "<AWS_DynamoDB_vs_RDS />": AWS_DynamoDB_vs_RDS,
  "<AWS_EBS />": AWS_EBS,
  "<AWS_EBS_vs_S3 />": AWS_EBS_vs_S3,
  "<AWS_Elastic_File_System />": AWS_Elastic_File_System,
  "<AWS_Instance_Stores />": AWS_Instance_Stores,
  "<AWS_RDS />": AWS_RDS,
  "<AWS_Redshift />": AWS_Redshift,
  "<AWS_S3 />": AWS_S3,

  // More AWS
  "<AWS_Machine_Learning />": AWS_Machine_Learning,
  "<AWS_Serverless_More />": AWS_Serverless_More,
};

export default AllAwsComponents;
